import {
  SingleProviderConfig,
  ShopType,
  CheckoutType,
  CrossSellType,
} from 'types';
import { allLeadMode, getDefaultCrossSellAction } from 'config';
import { CenturyLinkTheme } from 'config/themes';
import {
  ATT,
  Brightspeed,
  BrightspeedV2,
  CenturyLink,
  Frontier,
  Windstream,
  CincinnatiBell,
  Verizon,
  //Earthlink,
  Comcast,
  Cox,
  Spectrum,
  Optimum,
  Wave,
  Grande,
  RCN,
  WOW,
  TDS,
  BuckeyeBroadband,
  Mediacom,
  FidiumFiber,
} from 'config/providers';

export const CenturyLinkSpecial: SingleProviderConfig = {
  name: 'CenturyLinkSpecial',
  micrositeCode: 'CenturyLink',
  mainProvider: CenturyLink,
  shopType: ShopType.SINGLE_PROVIDER,
  domain: 'centurylinkspecial.com',
  homepage: 'https://centurylinkspecial.com',
  title: 'CenturyLink Authorized Dealer',
  fallbackPhoneNumber: '866-256-8169',
  fallbackLeadModePhoneNumber: '866-495-3654',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: CenturyLinkTheme,
  needsDcSession: false,
  source: 'CenturyLink',
  noOffersRetry: 2,
  getCrossSellAction: getDefaultCrossSellAction,
  getCheckoutType: allLeadMode,
  crossSellProviders: [
    ATT,
    Verizon,
    Brightspeed,
    BrightspeedV2,
    Frontier,
    Windstream,
    CincinnatiBell,
    //Earthlink,
  ],
  updaterCrossSellActive: true,
  updaterCrossSellProviders: [
    Comcast,
    Cox,
    Spectrum,
    Optimum,
    Wave,
    Grande,
    RCN,
    WOW,
    TDS,
    BuckeyeBroadband,
    Mediacom,
    FidiumFiber,
  ],
};
